import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mw-300px" }
const _hoisted_2 = { class: "d-flex flex-stack mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold pe-10 text-gray-600 fs-4" }, "Total :", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(["text-end fw-bold fs-4", _ctx.total > 0 ? 'text-success' : 'text-danger'])
      }, _toDisplayString(_ctx.total) + " " + _toDisplayString(_ctx.clientCurrency ? _ctx.clientCurrency.code : ''), 3)
    ])
  ]))
}